"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var other_request_item_1 = __importDefault(require("~/components/users/estimates/requests/messages/other_request_list/other_request_item"));
var OtherRequestListContainer = function (_a) {
    var requests = _a.requests;
    var _b = (0, react_1.useState)(true), isCollapse = _b[0], setIsCollapse = _b[1];
    var requestWrapperClass = (0, classnames_1.default)("usersEstimatesMessagesOtherRequest-List_RequestWrapper", { "usersEstimatesMessagesOtherRequest-List_RequestWrapper-collapse": isCollapse });
    return (react_1.default.createElement("div", { className: "usersEstimatesMessagesOtherRequest-List_Container" },
        react_1.default.createElement("div", { className: "usersEstimatesMessagesOtherRequest-List_Header" },
            react_1.default.createElement("div", { className: "usersEstimatesMessagesOtherRequest-List_Title" },
                react_1.default.createElement("i", { className: "fa fa-comments usersEstimatesMessagesOtherRequest-List_TitleIcon" }),
                react_1.default.createElement("span", null, "\u540C\u3058\u7533\u3057\u8FBC\u307F\u306E\u30C1\u30E3\u30C3\u30C8\u4E00\u89A7"))),
        react_1.default.createElement("div", { className: requestWrapperClass }, requests.map(function (request) { return react_1.default.createElement(other_request_item_1.default, { key: request.store_name, request: request }); })),
        react_1.default.createElement("div", { className: "usersEstimatesMessagesOtherRequest-List_ToggleLabel", onClick: function () { return setIsCollapse(!isCollapse); } }, isCollapse ? "その他の業者も表示する" : "業者を5件のみ表示する")));
};
exports.default = OtherRequestListContainer;
